// vendor
import { RouteConfig } from "vue-router";

import { ManageAsset as ManageAssetComponent } from "@/components.assets/manage-asset";
import { ViewAssetHistory } from "@/components.assets/view-asset-history-route";
import { ViewAsset } from "@/components.assets/view-asset";
import { EditAsset } from "@/components.edit/edit-asset";

const viewKey = "manage-asset-$assetId";

export const ManageAsset:RouteConfig  = {
	path: "/assets/:assetId",
	// name: "manage-study",
	component: ManageAssetComponent,
	meta: {
		title: "Asset"
	},
	children:[
		{
			path: "",
			name:"view-asset",
			component:ViewAsset,
			meta: {
				viewKey,
			},
		},
		{
			path: "edit",
			name:"asset.edit",
			component:EditAsset,
			meta: {
				viewKey,
			},
		},
		{
			path: "history",
			name:"asset-history",
			component:ViewAssetHistory,
			meta: {
				viewKey,
			},
		},
	],
};